// Os canais que a Powerbizz oferece na criação de caixa. Os outros tipos continuam no código,
// herdados, mas não funcionam na plataforma: nem o cliente nem o super admin os vê, e o endereço
// direto de um deles volta para a escolha de canal. Decisão do Murilo em 23/09/2026.
//
// Para oferecer um canal de novo, basta incluí-lo aqui. Com um canal só, a tela "Escolha um
// canal" seria um clique à toa, e a rota vai direto para ele (ver `inbox.routes.js`).
const CANAIS_OFERECIDOS = ['whatsapp'];

// O Site volta, mas só para o super admin (26/09/2026): caixa de site é o que põe um agente
// no site de um cliente, e isso é trabalho da plataforma. O servidor recusa a criação a quem
// não é super admin (`InboxPolicy#create_web_widget?`); aqui é só a porta da frente.
//
// O Google Chat entra também só para o super admin (30/09/2026, GCHAT-01 D6): configurar a caixa
// exige mexer no console do Google Cloud do cliente (o app de Chat e a permissão da service
// account), e na v1 quem faz isso é a Powerbizz, não o administrador da conta.
const CANAIS_DO_SUPER_ADMIN = ['website', 'google_chat'];

export const canaisOferecidos = superAdmin =>
  superAdmin
    ? [...CANAIS_DO_SUPER_ADMIN, ...CANAIS_OFERECIDOS]
    : CANAIS_OFERECIDOS;
